import { BRAND } from "constants/brand";
import notfound from "assets/images/notfound.png";
import DropDownButtons from "components/Ui/DropDownButtons/DropDownButtons";
import TableBodyCells from "components/Ui/TableBodyCells/TableBodyCells";

const Slider = (props) => {
    const cellRenderers = {
        id: () => <td>{props.slider?.id}</td>,
        // The place in the list on screen, and the two moves. ↑ is toward the
        // first place, the image the app opens on.
        order: () => (
            <td className="slider-order">
                <span className="slider-order__place">{props.place}</span>
                <button
                    type="button"
                    className="slider-order__move"
                    disabled={props.isFirst}
                    aria-label={`قدّم «${props.slider?.title}» مكانًا`}
                    title="قدّم الصورة"
                    onClick={() => props.onMove(props.slider, "up")}
                >
                    ↑
                </button>
                <button
                    type="button"
                    className="slider-order__move"
                    disabled={props.isLast}
                    aria-label={`أخّر «${props.slider?.title}» مكانًا`}
                    title="أخّر الصورة"
                    onClick={() => props.onMove(props.slider, "down")}
                >
                    ↓
                </button>
            </td>
        ),
        title: () => (
            <td className="name">
                <span>
                    <div>
                        <img
                            src={props.slider.image ? props.slider.image : notfound}
                            alt="slider"
                        />
                    </div>
                    <div>
                        <h6>{props.slider?.title}</h6>
                    </div>
                </span>
            </td>
        ),
        vendor: () => <td>{props.slider?.user ? props.slider?.user.name : "لا يوجد"}</td>,
        link: () => (
            <td>
                {props.slider?.link ? (
                    <a href={props.slider.link} target="_blank" rel="noopener noreferrer">
                        {props.slider.link}
                    </a>
                ) : (
                    "لا يوجد"
                )}
            </td>
        ),
        city: () => <td>{props.slider?.city ? props.slider.city.name : "جميع المدن"}</td>,
        status: () => (
            <td>
                <button
                    className={`button ${props.slider?.isHidden ? "button-danger" : "button-success"}`}
                    style={{
                        padding: "4px 12px",
                        fontSize: "12px",
                        border: "none",
                        borderRadius: "4px",
                        cursor: "pointer",
                        backgroundColor: props.slider?.isHidden ? "#dc3545" : BRAND,
                        color: "#fff",
                    }}
                    onClick={() => props.onToggleHidden(props.slider.id)}
                >
                    {props.slider?.isHidden ? "مخفي" : "ظاهر"}
                </button>
            </td>
        ),
        actions: () => (
            <td>
                <DropDownButtons
                    slider={props.slider}
                    edit={() => {
                        props.setSelectedSliderValue(props.slider);
                        props.toggleEditForm();
                    }}
                    delete={() => {
                        props.setSelectedSliderValue(props.slider);
                        props.toggleDelete();
                    }}
                ></DropDownButtons>
            </td>
        ),
    };

    return (
        <tr className="item" style={{ opacity: props.slider?.isHidden ? 0.5 : 1 }}>
            <TableBodyCells visibleColumns={props.visibleColumns} renderers={cellRenderers} />
        </tr>
    );
};

export default Slider;
